import React, { Fragment } from "react";
import './PurpleTab.scss'

const PurpleTab = (props) =>
{
    return (
        <div className='purpleTab'>
            <div className='purpleHeader'>{props.title}</div>
            <div className='seperator'></div>
            <div className='tab-item-wrapper'>
                {props.children}
            </div>
        </div>
    ) ;
};

export default PurpleTab;
